<script setup lang="ts">
defineProps<{
  error: {
    statusCode: number
    statusMessage: string
    message: string
  }
}>()

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <NuxtLayout>
    <div class="min-h-screen flex items-center justify-center">
      <div class="text-center space-y-4">
        <h1 class="text-6xl font-bold text-primary">{{ error.statusCode }}</h1>
        <p class="text-xl text-gray-600 dark:text-gray-400">
          {{ error.statusCode === 404 ? 'Página não encontrada' : 'Algo deu errado' }}
        </p>
        <UButton color="primary" size="lg" @click="handleError">
          Voltar ao início
        </UButton>
      </div>
    </div>
  </NuxtLayout>
</template>
